<div class="flex flex-wrap">
  <tag [ngClass]="class" *ngFor="let tag of tagList$ | async" [showTooltip]="tag.showTooltip" [label]="tag.label"
    [minWidth]="tag.minWidth" [minHeight]="tag.minHeight" [showLabel]="tag.showLabel" [showDeleteIcon]="tag.showDeleteIcon" (click)="onTagClicked(tag)"
    [active]="tag.active" [icon]="tag.icon" [id]="tag.id" (iconClicked)="onIconClicked(tag)"></tag>
</div>
